export const REBOOKED = '/rebooked';
export const PING = '/ping';

